<template>
  <ShareLink title="Get event link" :link="url" :filename="filename" />
</template>
<script>
import { mapState } from "vuex";
import ShareLink from "@/components/share/ShareLink.vue";

export default {
  components: { ShareLink },
  props: ["event_id"],
  computed: {
    url() {
      return `${this.group.group_base_url || window.location.host}/event/${
        this.event_id
      }`;
    },
    filename() {
      return `${this.group.group_name}-event-${this.event_id}-qr-code.png`;
    },
    ...mapState(["group"]),
  },
};
</script>
